export default __webpack_public_path__ + "static/media/748.74e3c549.png";